import { useTranslation } from 'react-i18next'
import { TextLinkButton, IconCancelOutline, Text } from '@machobear/design-system'
import { useListingDashboardModals } from '../../../modals'
import { InsightBlock } from '../insight-block'

export const NoSponsor = () => {
  const { t } = useTranslation()
  const { showModal } = useListingDashboardModals()

  return (
    <InsightBlock testId="boost-listing" icon={<IconCancelOutline tone="tertiary" size="small" />}>
      <Text>
        <TextLinkButton onClick={showModal('sponsoredListing')} weight="regular">
          {t('Boost your listing')}
        </TextLinkButton>
      </Text>
      <Text>{t('Reach up to 300% more renters with front & centre placement')}</Text>
    </InsightBlock>
  )
}
